import { EventTracking, EventType } from '@app/tracking';
var FacebookPixel = /** @class */ (function () {
    function FacebookPixel(pixelId, scriptPath) {
        if (scriptPath === void 0) { scriptPath = 'https://connect.facebook.net/en_US/fbevents.js'; }
        // @ts-ignore
        !function (f, b, e, v, n, t, s) {
            // @ts-ignore
            if (f.fbq)
                return;
            n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
            // @ts-ignore
            if (!f._fbq)
                f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            // @ts-ignore
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            // @ts-ignore
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            // @ts-ignore
            s.parentNode.insertBefore(t, s);
        }(window, document, 'script', scriptPath);
        fbq('init', pixelId);
        if (window.laravelDebug) {
            console.log("\u2705 Facebook Pixel Tracking initialized for \"".concat(pixelId, "\""));
        }
        this.registerListeners();
    }
    FacebookPixel.prototype.registerListeners = function () {
        // Page view
        EventTracking.listen(EventType.PageView, function (_a) {
            var title = _a.title, path = _a.path;
            fbq('track', 'PageView');
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, function (_a) {
            var form = _a.form;
            fbq('track', 'Lead', {
                content_category: 'ContactForm',
                content_name: form
            });
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, function (_a) {
            var searchQuery = _a.searchQuery;
            fbq('track', 'FindLocation');
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, function (event) {
            fbq('track', 'AddToCart', {
                value: event.price,
                currency: event.currency
            });
        });
        // Shop Go to Checkout
        EventTracking.listen(EventType.EcommerceCheckout, function (event) {
            fbq('track', 'InitiateCheckout', {
                value: event.total,
                currency: event.currency,
                num_items: event.items.length,
                contents: event.items.map(function (item) { return ({
                    id: item.variant.sku,
                    quantity: item.quantity
                }); })
            });
        });
        // Custom events
        EventTracking.listen(EventType.Track, function (_a) {
            var category = _a.category, action = _a.action, label = _a.label, _b = _a.value, value = _b === void 0 ? '' : _b;
            if (category == 'E-Mail' || category == 'Phone') {
                fbq('track', 'Contact');
            }
            else {
                fbq('trackCustom', action, {
                    category: category,
                    label: label,
                    value: value
                });
            }
        });
    };
    return FacebookPixel;
}());
export default FacebookPixel;
